import React, { useState, useEffect } from 'react';
import { Shield, X } from 'lucide-react';
import { authAPI } from '@/services/api';

const ImpersonationBanner = () => {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    const checkImpersonation = () => {
      const raw = localStorage.getItem('impersonating');
      if (raw) {
        try {
          const data = JSON.parse(raw);
          if (data.expires && Date.now() < data.expires) {
            setInfo(data);
          } else {
            handleStop();
          }
        } catch {
          handleStop();
        }
      } else {
        setInfo(null);
      }
    };

    checkImpersonation();

    // Listen for storage changes (e.g. impersonation started in another tab)
    window.addEventListener('storage', checkImpersonation);
    return () => window.removeEventListener('storage', checkImpersonation);
  }, []);

  const handleStop = async () => {
    const superToken = localStorage.getItem('superadmin_token');
    localStorage.removeItem('impersonating');
    localStorage.removeItem('superadmin_token');
    setInfo(null);
    if (superToken) {
      // Restore superadmin token first
      localStorage.setItem('auth_token', superToken);
      
      // Fetch superadmin user data to restore localStorage.user
      try {
        const response = await authAPI.me();
        localStorage.setItem('user', JSON.stringify(response.data));
      } catch (err) {
        // If /me fails, just remove user and let login handle it
        localStorage.removeItem('user');
      }
      
      // Now navigate to platform
      window.location.href = '/platform';
    }
  };

  if (!info) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[100] bg-amber-500 text-black px-4 py-2 flex items-center justify-center gap-3 text-sm font-medium"
      data-testid="impersonation-banner"
    >
      <Shield size={16} />
      <span>IMPERSONATING: {info.email} ({info.name})</span>
      <button
        onClick={handleStop}
        className="ml-4 px-3 py-1 bg-black/20 hover:bg-black/30 rounded-lg flex items-center gap-1 transition-colors"
        data-testid="stop-impersonation-btn"
      >
        <X size={14} />
        Stop
      </button>
    </div>
  );
};

export default ImpersonationBanner;
